import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import Header from "../PackageInfo/Header";
import bb1 from "../../Images/Bhimashankar/bb1.jpg";
import bb2 from "../../Images/Bhimashankar/bb2.jpg";
import bb3 from "../../Images/Bhimashankar/bb3.jpg";
import bb4 from "../../Images/Bhimashankar/bb4.jpg";
import bb5 from "../../Images/Bhimashankar/bb5.JPG";
import bb6 from "../../Images/Bhimashankar/bb6.jpg";
import bb7 from "../../Images/Bhimashankar/bb7.jpg";
// import bb8 from "../../Images/Bhimashankar/bb8.jpg";
// import bb9 from "../../Images/Bhimashankar/bb9.JPG";
// import bb10 from "../../Images/Bhimashankar/bb10.jpg";
import bb11 from "../../Images/Bhimashankar/bb11.jpg";
import bb12 from "../../Images/Bhimashankar/bb12.jpg";

import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";

const data = [
  {
    day: "Day 1",
    subheading: "Kalas Darshan - Where Adventure Meets Spirituality",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:15 AM", activity: "Pick-up at Swargate." },
      { time: "05:25 AM", activity: "Pick-up at Chhatrapati Shivaji Nagar." },
      { time: "05:45 AM", activity: "Pick-up at Nashik Phata." },
      { time: "07:30 AM", activity: "En route breakfast.(approx)" },
      { time: "11:00 AM", activity: "Arrive at Bhimashankar – Kalas Darshan." },
      { time: "11:30 AM", activity: "Start trek towards Bhorgiri." },
      {
        time: "12:30 PM",
        activity: "Reach Gupt Bhimashankar – take blessings.",
      },
      { time: "04:00 PM", activity: "Reach and Lunch at base village." },
      { time: "06:00 PM", activity: "Begin return journey to Pune." },
      { time: "08:00 PM", activity: "Tea break (if time permits)." },
      {
        time: "10:00 PM",
        activity: "Arrival in Pune – drop at respective points.",
      },
    ],
    meals: ["Breakfast", "Lunch"],
    notes: [
      "The tour will include Kalas Darshan only and will not include a visit to Bhimashankar Temple due to anticipated rush and crowd.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg Lunch",
      "🩺 Basic First Aid & Hydration Powder",
      "🧭 Experienced Trek Lead & Guide",
      "🌿 Entry fees",
    ],

    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Any Mineral water, Cold drinks, Personal food expenses, Extra breakfast, meals etc.",
      "Personal expenses or insurance",
    ],

    verticalCards: [
      { title: "Bhimashankar", image: bb1 },
      { title: "Bhimashankar", image: bb2 },
      { title: "Bhimashankar", image: bb11 },
      { title: "Bhimashankar", image: bb12 },
      { title: "Bhimashankar", image: bb3 },
      { title: "Bhimashankar", image: bb4 },
      { title: "Bhimashankar", image: bb5 },
      { title: "Bhimashankar", image: bb6 },
      // { title: "Bhimashankar", image: bb7 },
      // { title: "Bhimashankar", image: bb8 },
      // { title: "Bhimashankar", image: bb9 },
      // { title: "Bhimashankar", image: bb10 },
    ],
    trekData: [
      {
        name: "Bhimashankar to Bhorgiri",
        image: bb7, // Example Unsplash image
        info: "The Bhimashankar to Bhorgiri trek spans about 7 to 8 km and takes 4–5 hours to complete. This moderately challenging trail winds through the lush Bhimashankar Wildlife Sanctuary, home to the rare Giant Squirrel (Shekaru), Maharashtra’s state animal. Along the way, you'll encounter dense forests, waterfalls, and scenic views. A major highlight is the Gupt Bhimashankar shrine, believed to be one of the original Jyotirlingas. The trek ends in the serene village of Bhorgiri, blending adventure, nature, and spirituality.",
      },
    ],

    faq: [
      {
        question: "Is the Bhimashankar Temple visit included?",
        answer:
          "No, the visit to Bhimashankar Temple will not be included. Instead, there will be a Kalas darshan, and blessings will be sought from Gupt Bhimashankar due to the rush and crowd.",
      },
      {
        question:
          "What is the difficulty level of the Bhimashankar to Bhorgiri trek?",
        answer:
          "The trek is moderately difficult and suitable for beginners with decent fitness. The route involves forest trails, rocky patches, and some steep descents, especially near Bhorgiri.",
      },
      {
        question: "Are washrooms and changing rooms available?",
        answer:
          "Yes, washrooms and changing rooms are available at the base village. However, there are no facilities during the trek.",
      },
      {
        question: "Is this trek suitable for solo travelers?",
        answer:
          "Yes, we welcome solo trekkers. Many of our participants join solo and have a great experience.",
      },
      {
        question: "Do you have girl volunteers or trek leads?",
        answer:
          "Yes, we have female volunteers and trek leads available on our treks for added comfort and safety.",
      },
      {
        question: "Is medical assistance available?",
        answer:
          "Basic first aid will be available during the trek. Participants are advised to carry any personal medications they may require.",
      },
      {
        question: "What about extra baggage?",
        answer:
          "You can safely keep your extra bags in the bus during the trek, but please note it is at your own responsibility.",
      },
      {
        question: "What type of bus is provided?",
        answer:
          "The trek includes transportation in a NON-AC Seater Bus, which could be a 17-seater or 32-seater depending on the number of participants, ensuring decent seating comfort.",
      },
      {
        question: "What are the pickup points for the trek?",
        answer:
          "Pick-up points for the trek include Hadapsar, Swargate at 05:15 AM, Chhatrapati Shivaji Nagar at 05:25 AM, and Nashik Phata at 05:45 AM.",
      },

      {
        question: "Is prior trekking experience required?",
        answer:
          "No prior trekking experience is required, but a reasonable level of fitness is recommended as the trail includes both ascents and descents through dense forest and rocky terrain.",
      },
      {
        question: "Are guides provided for this trek?",
        answer:
          "Yes, experienced local trek leaders will accompany the group to ensure safety and guide you through the forest paths and village trails.",
      },
      {
        question: "Is there mobile network coverage on the trail?",
        answer:
          "Network coverage is patchy, especially in the forested sections. Do inform your family or friends in advance if you plan to be off-grid for a while.",
      },
      {
        question: "Are meals provided during the trek?",
        answer:
          "Yes, local vegetarian breakfast and lunch are usually included in the package. Carry light snacks for energy during the trek.",
      },
    ],
  },
];

const Bhimashankar = () => {
  // This line seems misplaced, it should be part of the ModalTriggerList
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <TrekBasicInfo
        trekName="Reverse Waterfall & Naneghat Trek"
        location="Junnar"
        trekDifficulty="Easy"
        ageLimit="16 to 36 Years"
      />
      <PackageInclusions />
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default Bhimashankar;
